<img class="loader" src="../../assets/loader1.gif">
